import React from 'react';
import { Button, Modal, Icon, Spin } from 'antd';
import styles from './ExportModal.module.less';

const loadingIcon = <Icon type="loading" spin />;

type ExportModalProps = {
  visible: boolean;
  isCategory?: boolean;
  onCancel: () => void;
  onComplete: () => void;
};

export const ExportModal: React.FC<ExportModalProps> = ({ visible, onCancel, onComplete,isCategory }) => {
  const title = (
    <>
      {isCategory ? 'Exporting Categories' : 'Exporting Alert Results'} ...
      <Spin indicator={loadingIcon} size={'large'} spinning={true} />
    </>
  );

  return (
    <Modal
      className={styles.modal}
      title={title}
      visible={visible}
      closable={false}
      afterClose={onComplete}
      footer={
        <Button type="primary" onClick={onCancel}>
          Cancel
        </Button>
      }
    />
  );
};
